export default "__VITE_ASSET__DYjUtNL6__"